import { useEffect, useRef } from 'react';
import { useBiLogger } from '../bi-hooks/useBiLogger';
import { getStaticBiEventsFields } from '../bi-hooks/useCommonBiEventsFields';
const PLANS_PAGE_SCROLL_SRC = 17;
const PLANS_PAGE_SCROLL_EVID = 1099;
export const useFoldScrollBiEvent = _ref => {
  let {
    selector,
    foldName,
    pageName,
    deviceType
  } = _ref;
  const {
    biLogger
  } = useBiLogger();
  const hasFiredRef = useRef(false);
  useEffect(() => {
    const element = document.querySelector(selector);
    if (!element || !biLogger || hasFiredRef.current || !(foldName != null && foldName.trim())) {
      return;
    }
    const observer = new IntersectionObserver(entries => {
      if (!hasFiredRef.current && entries.some(entry => entry.isIntersecting)) {
        hasFiredRef.current = true;
        biLogger.report({
          src: PLANS_PAGE_SCROLL_SRC,
          evid: PLANS_PAGE_SCROLL_EVID,
          endpoint: '',
          params: {
            ...getStaticBiEventsFields(),
            pageName,
            pageUrl: window.location.href,
            foldName,
            foldNumber: Math.round(window.scrollY),
            deviceType
          }
        });
        observer.disconnect();
      }
    }, {
      threshold: 0.5
    });
    observer.observe(element);
    return () => observer.disconnect();
  }, [selector, biLogger, foldName, pageName, deviceType]);
};
//# sourceMappingURL=useFoldScrollBiEvent.js.map